
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import Settings from "./pages/Settings";
import HomepageLeads from './pages/leads/HomepageLeads';
import ContactLeads from './pages/leads/ContactLeads';
import CountryLeads from './pages/leads/CountryLeads';
import LandingPageLeads from './pages/leads/LandingPageLeads';

import AllLeads from './pages/leads/AllLeads';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/leads/home" element={<HomepageLeads />} />
        <Route path="/leads/contact" element={<ContactLeads />} />
        <Route path="/leads/country" element={<CountryLeads />} />
        <Route path="/leads/landing" element={<LandingPageLeads />} />
      
        <Route path="/leads" element={<AllLeads />} />
      </Routes>
    </Router>
  );
}
export default App;
